import {useNavigate, useLocation} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {updateModalProduct} from 'redux/actions/product'
const ignorePaths = ['/', '/login', '/signup', '/forgot-password']

export function useGotoLogin() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  return () => {
    let from = location?.pathname + location?.search || '/'
    if (ignorePaths.includes(location?.pathname)) {
      from = '/'
    } 
    sessionStorage.setItem('_aog_login_redirect_url', from)
    dispatch(updateModalProduct(undefined))
    navigate('/login', {replace: true, state: {from}})
  }
}
